/**
 * This method provides a way for Java to call JavaScript, and a way for 
 * JavaScript to expose methods to Java.
 * An instances of this class is attached to window.cmsInterface.
 * In java the "cmsInterface" name is stored in "CoreUI.JS_BASE_CLASS"
 * 
 * This class uses a JavaScript proxy to make registered objects easy to access.
 * For example, the instance of "SiteEditor" is registered:
 * 		CmsInterface.getInstance().set("siteEditor", instoreOfSiteEditor);
 * And can then be called from the global scope as:
 * 		cmsInterface.setEditor.methodOnSiteEditor()
 */
export default class CmsInterface {
	private static instance: CmsInterface;

	private registry: Map<string, any>;

	static getInstance(): CmsInterface {
		if (CmsInterface.instance === undefined) {
			CmsInterface.instance = new CmsInterface();
		}
		return CmsInterface.instance;
	}

	constructor() {
		this.get = this.get.bind(this);
		this.registry = new Map<string, any>();

		(window as any).cmsInterface = new Proxy({}, {
			get: (target: any, property: string, receiver: any): any => {
				return this.get(property);
			}
		});
	}

	public get(property: string): any {
		return this.registry.get(property);
	}

	public set(property: string, obj: any) {
		this.registry.set(property, obj);
	}

	public delete(property: string) {
		this.registry.delete(property);
	}
}

CmsInterface.getInstance(); // Self init.
